import { hasCapability, type User } from "../base";

export const serviceAreaPause = {
  update: (user: User, contractorProfileId: string) =>
    user.person.organizationId === contractorProfileId && hasCapability(user, "serviceArea.pause.org"),
  clear: (user: User) => hasCapability(user, "serviceArea.pause.clear"),
};
